var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "relative-position layout-padding" }, [
      _c("div", { staticClass: "sl-row" }, [
        _c("div", { staticClass: "sl-col-12" }, [
          _c(
            "p",
            {
              staticClass: "text-center",
              staticStyle: { "max-width": "350px", margin: "0 auto" }
            },
            [
              _vm._v(
                "You have completed the new user wizard modal. Finish to close the wizard."
              )
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }